"use client";

import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  useTheme,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
const BookModal = ({ accommodation, open, onClose, data }) => {
  const { roomTypeName, checkin, checkout, propertyName, id } = accommodation;

  // URL encode the parameters to handle spaces and special characters
  const encodedRoom = encodeURIComponent(roomTypeName);
  const encodedResidence = encodeURIComponent(propertyName);
  const encodedCheckin = checkin; // dates don't need encoding
  const encodedCheckout = checkout; // dates don't need encoding
  const encodedGapId = id; // numbers don't need encoding
  const theme = useTheme();

  const iframeUrl = `https://landing.londonist.co.uk/checkout-gap?room=${encodedRoom}&checkin=${encodedCheckin}&checkout=${encodedCheckout}&residence=${encodedResidence}&gapid=${encodedGapId}&utm_source=Partner_Portal_Book_The_Gap&utm_medium=Partner_Portal_Book_The_Gap&utm_term=Partner_Portal_Book_The_Gap&utm_campaign=Partner_Portal_Book_The_Gap&utm_content=Partner_Portal_Book_The_Gap`;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          margin: 0,
          maxWidth: "none",
          maxHeight: "none",
          height: "100vh",
          width: "100vw",
          borderRadius: 0,
        },
      }}
    >
      <Box
        sx={{
          position: "fixed",
          right: 32,
          top: 32,
          display: "flex",
          alignItems: "center",
          background: "#fff",
          borderRadius: "10rem",
          filter: "drop-shadow(0 0 3px #cfcfcf)",
        }}
      >
        <IconButton onClick={onClose} size="small">
          <CloseIcon
            sx={{
              color: theme.palette.customRed.orange,
            }}
          />
        </IconButton>
      </Box>

      <DialogContent dividers sx={{ overflow: "hidden", p: 0 }}>
        <iframe
          src={iframeUrl}
          width="100%"
          height="100%"
          style={{
            border: "none",
          }}
          allowFullScreen
          loading="lazy"
          title="Booking Form"
        ></iframe>
      </DialogContent>
    </Dialog>
  );
};

export default BookModal;
